import styles from "./Layout.module.scss";
import classNames from "classnames";
import React from "react";

const StickyContainer = ({ children, className, style, includeTopPadding = false }) => {
    return <div className={classNames(styles['sticky-container'], className, {[styles['with-top-padding']]: includeTopPadding})} style={style}>
        {children}
    </div>
};

export default StickyContainer;